import { Controller } from "stimulus"

export default class extends Controller {
  static values = { url: String }

  billingCodeLabel(code) {
    return {
      "90899": "90899 (Initial Evaluation)",
      "99214": "99214 (Renewal Visit)",
      "90792": "90792 (New Patient Visit)"
    }[code] || code || "—"
  }

  connect() {
    // console.log("ReviewedLaunchController connected")
  }

  open(event) {
    event.preventDefault()

    const url = event.currentTarget.dataset.url
    const modalEl = document.getElementById("reviewedConfirmModal")

    modalEl.dataset.confirmBillingUrl = url
    modalEl.dataset.uploaderName = event.currentTarget.dataset.uploaderName
    modalEl.dataset.billingCode = event.currentTarget.dataset.billingCode
    modalEl.dataset.isReviewed = event.currentTarget.dataset.isReviewed
    modalEl.dataset.previouslyBilled = event.currentTarget.dataset.previouslyBilled
    modalEl.querySelector("#reviewed-document-uploader").textContent = modalEl.dataset.uploaderName || "—"
    modalEl.querySelector("#reviewed-billing-code").textContent = this.billingCodeLabel(modalEl.dataset.billingCode)
    modalEl.querySelector("#reviewed-billing-code-select").value = modalEl.dataset.billingCode || "99214"
    modalEl.querySelector("#reviewed-billing-code-selector").style.display = "none"

    window.$(modalEl).modal("show")

    // const modalEl = document.getElementById("reviewedConfirmModal")
    // modalEl.dataset.reviewedConfirmUrlValue = this.urlValue

    // window.$(modalEl).modal("show")
  }
}
